<template>
  <div>
    <ul v-if="comparisonToolList.length" class="selected-tool-list">
      <li
        v-for="selectedTool in comparisonToolList"
        :key="selectedTool.id"
        class="selected-tool"
      >
        <span>
          {{ selectedTool.name }}
        </span>
        <fa
          icon="times-circle"
          class="selected-tool__remove-icon"
          @click="removeFromComparisonToolList(selectedTool)"
        ></fa>
      </li>
    </ul>

    <p v-show="isReachLimit" class="tip-text warning">
      {{ $t('comparisonFeature.tools.selectionLimitWarningMsg') }}
    </p>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {};
  },

  computed: {
    ...mapState(['comparisonToolList']),

    isReachLimit() {
      return this.comparisonToolList.length === 6;
    },
  },

  methods: {
    ...mapMutations(['updateComparisonToolList']),

    removeFromComparisonToolList(selectedTool) {
      const updatedToolList = this.comparisonToolList.filter(
        (item) => item.name !== selectedTool.name
      );
      this.updateComparisonToolList(updatedToolList);
    },
  },

  mounted() {},
};
</script>

<style scoped lang="scss">
.selected-tool-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  height: 100%;
  padding: 0.25rem 0;
  margin: 0;
  margin-right: 1rem;
  overflow: hidden;
}
.selected-tool {
  flex: 0 1 30%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 0.25rem 0.25rem;
  padding: 0 0.5rem;
  box-sizing: border-box;
  min-width: 8rem;
  height: 2.75rem;
  line-height: 2.75rem;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14),
    0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);

  span {
    display: inline-block;
    margin-right: 0.5rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: $text-black;
  }

  &__remove-icon {
    width: 1.25rem;
    height: 1.25rem;
    font-size: 0.5rem;
    color: $icon-grey;
    cursor: pointer;
  }
}

.tip-text {
  margin: 0;
  margin-top: -0.2rem;
  padding: 0 0.5rem;
}
.warning {
  color: $warning-red;
}

@include responsive(mobile) {
  .selected-tool {
    flex: 0 1 45%;
  }
  .tip-text {
    margin-top: 0;
  }
}
</style>
